module.exports = __webpack_public_path__ + "img/advertiseMobile.09d1d291.gif";